import React, { useState, useEffect } from 'react'; 
import Navbar from '../Navbar/Navbar';
import './RentalEdit.scss';
import { useParams, useNavigate  } from 'react-router-dom';
import api from '../Axios/axios';

const createRentalChargeItem = () => ({
  localId: `rental-charge-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  id: 0,
  description: '',
  quantity: 1,
  unitPrice: ''
});

const RentalEdit = ({ role }) => {
  const { rentalId } = useParams();
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const decoded = JSON.parse(atob(token.split('.')[1]));
      const roleClaim = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      setUserRole(roleClaim);
    } catch (e) {
      console.error("token decode failed", e);
    }
  }, []);
  const [machineRenters, setMachineRenters] = useState([]);
  const [rentalDetails, setRentalDetails] = useState({
    machineRentCompanyId: '',
    craneOwner: '',
    serialNo: '',
    brand: '',
    craneCode: '',
    height: '',
    maxTonnage: '',
    rentalCompany: '',
    site: '',
    chassisType: '',
    walkingSystem: '',
    installationHeight: '',
    JibLength: '',
    rentalDuration: '',
    rentalFee: '',
    invoiceInstallmentCount: '',
    firstInvoiceDate: '',
    startDate: '',
    endDate: '',
    hasExtraPeriod: false,
    extraPeriod: '',
    extraPeriodMonth: 0, 
    notes: [{ id: 1, note: '' }],
    lineItems: [createRentalChargeItem()]
    
  });
  
  const [files, setFiles] = useState([]);
  const [showEndRentalModal, setShowEndRentalModal] = useState(false);
  const [showDepotModal, setShowDepotModal] = useState(false);
  const [warehouseId, setWarehouseId] = useState('');
  const [warehouses, setWarehouses] = useState([]);
  const [newDepotName, setNewDepotName] = useState('');
  const [newDepotAddress, setNewDepotAddress] = useState('');
  

  useEffect(() => {
    if (rentalId) {
      fetchRentalDetails(rentalId);
    fetchMachineRenters();

    }
    fetchWarehouses();
  }, [rentalId]);
const fetchMachineRenters = async () => {
  try {
    const res = await api.get('/Company');
    setMachineRenters((res?.data?.data || []).filter(c => c.rentTowerCrane === true));
  } catch (err) {
    console.error('Makine kiralayan firmalar yüklenemedi:', err);
  }
};
  const fetchRentalDetails = async (id) => {
    try {
      const rentalResponse = await api.get(`/Rental/GetById?id=${id}`);
      const rentalData = rentalResponse.data.data;

      console.log("rentalDataFiles : ", rentalData.files)

      rentalData.files.forEach((item, index) => {

        var isExist = files.find(x => x.id === item.id)
        if(!isExist){
            files.push({id : item.id, file : null, fileType : item.fileType, fileName : item.fileName})
        }
      })

      console.log("files : ", files)

      const towerCraneResponse = await api.get(`/TowerCrane/GetById?id=${rentalData.towerCraneId}`);
      const towerCraneData = towerCraneResponse.data.data;

      setRentalDetails({
        craneOwner: rentalData.owner || '',
        machineRentCompanyId: rentalData.rentingMachineCompanyId || '',
        serialNo: towerCraneData.serialNo || '',
        brand: towerCraneData.brand || '',
        craneCode: towerCraneData.model || '',
        height: towerCraneData.height || '',
        maxTonnage: towerCraneData.maxTonnage || '',
        rentalCompany: rentalData.rentingCompany || '',
        site: rentalData.workSite || '',
        chassisType: rentalData.type === "Chassis" ? "Şaseli" : "Ankarajlı",
        walkingSystem: rentalData.hasWalkingGear ? "Var" : "Yok",
        installationHeight: rentalData.installedHeight || '',
        JibLength: rentalData.jibLength || '',
        rentalDuration: rentalData.rentalPeriod || '',
        rentalFee: rentalData.rent || '',
        invoiceInstallmentCount: rentalData.invoiceInstallmentCount || rentalData.rentalPeriod || '',
        firstInvoiceDate:
          (rentalData.firstInvoiceDate && rentalData.firstInvoiceDate.split('T')[0]) ||
          (rentalData.rentalStartDate && rentalData.rentalStartDate.split('T')[0]) ||
          '',
        startDate: rentalData.rentalStartDate.split('T')[0] || '',
        endDate: rentalData.rentalEndDate.split('T')[0] || '',
        HasExtraTime: rentalDetails.hasExtraPeriod,
        ExtraPeriod: rentalDetails.hasExtraPeriod 
          ? parseInt(rentalDetails.extraPeriod, 10) || 0 
          : 0,
        notes: rentalData.notes, 
        hasExtraPeriod: rentalData.hasExtraPeriod || false, 
        extraPeriod: rentalData.extraPeriod ? parseInt(rentalData.extraPeriod, 10) : 0,
        extraPeriodMonth:rentalData.extraPeriodMonth || 0,
        lineItems:
          (rentalData.lineItems || rentalData.LineItems || []).length > 0
            ? (rentalData.lineItems || rentalData.LineItems || []).map((item, index) => ({
                localId: `rental-charge-${item.id || index}`,
                id: item.id || 0,
                description: item.description || '',
                quantity: item.quantity || 1,
                unitPrice: item.unitPrice || ''
              }))
            : [createRentalChargeItem()],
      });
        // rentalData.files'ı organize ederek her bir fileType için file ve fileName ile ekle
        const organizedFiles = rentalData.files.map(file => ({
          fileType: file.fileType,
          file: file.fileName, // fileName'i file olarak set ediyoruz
          id: file.id
      }));
        
        console.log("Organized Files:", organizedFiles); // Organized files loglama
        setFiles(organizedFiles); // Doğrudan dizi olarak dosyaları ekleme

    } catch (error) {
      console.error('Veri çekme hatası:', error);
    }
  };
  useEffect(() => {
    console.log("Updated files:", files);
  }, [files]); // `files` durumu değiştikçe bu etki çalışır
  const fetchWarehouses = async () => {
    try {
      const response = await api.get('/Warehouse');
      setWarehouses(response.data.data);
    } catch (error) {
      console.error('Depolar yüklenemedi:', error);
    }
  };
useEffect(() => {
  const { startDate, rentalDuration, hasExtraPeriod, extraPeriodMonth, extraPeriod } = rentalDetails;
  if (!startDate) return;

  const end = new Date(startDate);
  // Ana kira süresi (ay)
  end.setMonth(end.getMonth() + (parseInt(rentalDuration, 10) || 0));
  if (hasExtraPeriod) {
    // Ekstra ay
    end.setMonth(end.getMonth() + extraPeriodMonth);
    // Ekstra gün
    end.setDate(end.getDate() + extraPeriod );
  }
 end.setDate(end.getDate() - 1);

  setRentalDetails(prev => ({
    ...prev,
    endDate: end.toISOString().slice(0, 10)
  }));
}, [
  rentalDetails.startDate,
  rentalDetails.rentalDuration,
  rentalDetails.hasExtraPeriod,
  rentalDetails.extraPeriodMonth,
  rentalDetails.extraPeriod
]);


  
const handleRentalDetailChange = (e) => {
  const { name, value, type } = e.target;
  let newValue;

  if (type === 'number') {
    // Diğer tüm number input’lar eski davranışla devam etsin
    newValue = parseFloat(value) || '';
  } else {
    newValue = value;
  }

  setRentalDetails(prev => {
    const nextDetails = {
      ...prev,
      [name]: newValue
    };

    if (name === 'rentalDuration') {
      const currentInstallmentCount = String(prev.invoiceInstallmentCount || '');
      const currentRentalDuration = String(prev.rentalDuration || '');
      if (!currentInstallmentCount || currentInstallmentCount === currentRentalDuration) {
        nextDetails.invoiceInstallmentCount = value;
      }
    }

    if (name === 'startDate') {
      const currentFirstInvoiceDate = prev.firstInvoiceDate || '';
      const currentStartDate = prev.startDate || '';
      if (!currentFirstInvoiceDate || currentFirstInvoiceDate === currentStartDate) {
        nextDetails.firstInvoiceDate = value;
      }
    }

    return nextDetails;
  });
};


  
  
  const handleFileChange = (e, fileType) => {

    var allFiles = e.target.files;

    for (let index = 0; index < allFiles.length; index++) {
      const element = allFiles[index];

      var f = files.find(x => x.fileName === element.name && x.fileType === fileType);
      if(f){
        f.file = Array.from(element) 
        f.file = [element]
      }
      else{
        files.push({
          id : 0,
          fileType: fileType, 
          file: Array.from(element), 
          file: [element],
          fileName : element.name
        })
      }
    }
};
  
  
const handleNoteChange = (index, value) => {
  const updatedNotes = [...rentalDetails.notes];
  updatedNotes[index].note = value; // Doğru alan güncelleniyor
  setRentalDetails({ ...rentalDetails, notes: updatedNotes });
};

const addNote = () => {
  setRentalDetails((prevState) => ({
    ...prevState,
    notes: [...prevState.notes, { id: prevState.notes.length + 1, note: '' }],
  }));
};

const handleLineItemChange = (localId, field, value) => {
  setRentalDetails((prevState) => ({
    ...prevState,
    lineItems: (prevState.lineItems || []).map((item) =>
      item.localId === localId ? { ...item, [field]: value } : item
    )
  }));
};

const addLineItem = () => {
  setRentalDetails((prevState) => ({
    ...prevState,
    lineItems: [...(prevState.lineItems || []), createRentalChargeItem()]
  }));
};

const removeLineItem = (localId) => {
  setRentalDetails((prevState) => ({
    ...prevState,
    lineItems:
      (prevState.lineItems || []).length > 1
        ? prevState.lineItems.filter((item) => item.localId !== localId)
        : prevState.lineItems
  }));
};


const handleMachineRenterChange = e => {
   const val = e.target.value;
   setRentalDetails(d => ({
     ...d,
     machineRentCompanyId: val
   }));
 };
const handleRentalSubmit = async () => {
    try {
      const rentalData = {
        Id: rentalId,
        InstalledHeight: rentalDetails.installationHeight,
        JibLength: rentalDetails.JibLength,
        RentalPeriod: rentalDetails.rentalDuration,
        Rent: rentalDetails.rentalFee,
        InvoiceInstallmentCount:
          rentalDetails.invoiceInstallmentCount || rentalDetails.rentalDuration,
        FirstInvoiceDate: rentalDetails.firstInvoiceDate || rentalDetails.startDate,
        RentingMachineCompanyId:rentalDetails.machineRentCompanyId,
        Type: rentalDetails.chassisType === "Şaseli" ? "Chassis" : "Anchored",
        HasWalkingGear: rentalDetails.walkingSystem === "Var",
        RentalStartDate: rentalDetails.startDate,
        RentalEndDate: rentalDetails.endDate,
        HasExtraTime: rentalDetails.hasExtraPeriod,
        ExtraPeriod: rentalDetails.extraPeriod || 0,
        ExtraPeriodMonth: rentalDetails.extraPeriodMonth || 0,
      };

      const formData = new FormData();
      console.log(rentalData);

      Object.keys(rentalData).forEach(key => {
        formData.append(key, rentalData[key]);
      });

      // Notları FormData'ya ekleyin
      rentalDetails.notes.forEach((item, index) => { 
        formData.append(`Notes[${index}]`, item.note); 
      });
      (rentalDetails.lineItems || [])
        .filter(
          (item) =>
            String(item.description || '').trim() &&
            Number(item.quantity || 0) > 0 &&
            Number(item.unitPrice || 0) > 0
        )
        .forEach((item, index) => {
          if (item.id) {
            formData.append(`LineItems[${index}].Id`, item.id);
          }
          formData.append(`LineItems[${index}].Description`, item.description.trim());
          formData.append(`LineItems[${index}].Quantity`, Number(item.quantity || 0));
          formData.append(`LineItems[${index}].UnitPrice`, Number(item.unitPrice || 0));
          formData.append(
            `LineItems[${index}].Amount`,
            Number(item.quantity || 0) * Number(item.unitPrice || 0)
          );
          formData.append(`LineItems[${index}].ItemType`, 'OneTime');
          formData.append(`LineItems[${index}].SortOrder`, index);
        });
        // Dosyaları formData'ya ekle
        if (files && files.length > 0) {
          files.forEach((item, index) => {
            formData.append(`Files[${index}].id`, item.id);
            formData.append(`Files[${index}].file`, item.file[0]);
            formData.append(`Files[${index}].fileType`, item.fileType);
          });
      }
      
    // FormData içeriğini yazdır
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }      
    const response = await api.put(`/Rental`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(`Yükleme İlerlemesi: ${percentCompleted}%`);
          // Progress bar için setState kullanabilirsiniz
        },
      });
      
      navigate(0);
      console.log('Kiralama güncelleme başarılı:', response.data);
    } catch (error) {
      console.error('Kiralama güncelleme hatası:', error);
    }
  };

const handleRentalEnd = async () => {
    try {
      await api.patch('/Rental', { id: rentalId, warehouseId });
      console.log('Kiralama başarıyla sona erdi');
      setShowEndRentalModal(false);
      navigate(0);
    } catch (error) {
      console.error('Kiralama bitirme hatası:', error);
    }
  };

  const handleAddDepot = async () => {
    if (newDepotName && newDepotAddress) {
      try {
        const response = await api.post('/Warehouse', { name: newDepotName, address: newDepotAddress });
        const addedDepot = response.data?.data || {};
        if (addedDepot.id) {
          setWarehouses([...warehouses, addedDepot]);
          setNewDepotName('');
          setNewDepotAddress('');
          setShowDepotModal(false);
          navigate(0);

        }
      } catch (error) {
        console.error('Depo eklenemedi:', error);
      }
    }
  };

  return (
    <div className="rental-edit-page">
      <Navbar />
      <div className="rental-form">
        <h2>Kira Düzenle</h2>
  
          <div className="form-row">
          <div className="form-group">
          <label>Makine Kiralayan Firma</label>
          <select
            name="machineRentCompanyId"
            value={rentalDetails.machineRentCompanyId}
            onChange={handleMachineRenterChange}
            disabled={userRole!=='Owner'}
          >
            <option value="">Seçin…</option>
            {machineRenters.map(c=>(
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Kule Vinç Sahibi Firma</label>
            <input
              type="text"
              name="craneOwner"
              value={rentalDetails.craneOwner}
              onChange={handleRentalDetailChange}
              disabled
            />
          </div>
        </div>
  
        <div className="form-row">
          <div className="form-group craneinfos">
            <label><b>Seri No:</b> {rentalDetails.serialNo}</label>
            <label><b>Marka:</b> {rentalDetails.brand}</label>
            <label><b>Vinç Kodu:</b> {rentalDetails.craneCode}</label>
            <label><b>Yükseklik:</b> {rentalDetails.height} m</label>
            <label><b>Maksimum Tonaj:</b> {rentalDetails.maxTonnage}T</label>
          </div>
        </div>
  
        <div className="form-row">
          <div className="form-group">
            <label>Kiralayan Firma</label>
            <input
              type="text"
              name="rentalCompany"
              value={rentalDetails.rentalCompany}
              onChange={handleRentalDetailChange}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Şantiye</label>
            <input
              type="text"
              name="site"
              value={rentalDetails.site}
              onChange={handleRentalDetailChange}
              disabled
            />
          </div>
        </div>
  
        <div className="form-row">
          <div className="form-group">
            <label>Şaseli mi? Ankarajlı mı?</label>
            <select name="chassisType" value={rentalDetails.chassisType} onChange={handleRentalDetailChange} disabled={userRole !== 'Owner'}>
              <option value="">Seçin</option>
              <option value="Şaseli">Şaseli</option>
              <option value="Ankarajlı">Ankarajlı</option>
            </select>
          </div>
          <div className="form-group">
            <label>Yürüyüş Takımı Var mı?</label>
            <select name="walkingSystem" value={rentalDetails.walkingSystem} onChange={handleRentalDetailChange} disabled={role !== 'Owner'}>
              <option value="">Seçin</option>
              <option value="Var">Var</option>
              <option value="Yok">Yok</option>
            </select>
          </div>
        </div>
  
        <div className="form-row">
          <div className="form-group">
            <label>Kaç Metre Yüksekliğe Kuruluyor?</label>
            <input
              type="number"
              name="installationHeight"
              value={rentalDetails.installationHeight}
              onChange={handleRentalDetailChange}
            />
          </div>
            <div className="form-group">
          <label>Kurulan Bom Uzunluğu (m)</label>
          <input
            type="number"
            name="JibLength"
            value={rentalDetails.JibLength}
            onChange={handleRentalDetailChange}
          />
        </div>
          <div className="form-group">
            <label>Kira Süresi (Ay)</label>
            <input
              type="number"
              name="rentalDuration"
              value={rentalDetails.rentalDuration}
              onChange={handleRentalDetailChange}
            />
          </div>
        </div>
  
        <div className="form-row">
          <div className="form-group">
            <label>Kira Bedeli</label>
            <input
              type="number"
              name="rentalFee"
              value={rentalDetails.rentalFee}
              onChange={handleRentalDetailChange}
            />
          </div>
          <div className="form-group">
            <label>Fatura Taksit Sayısı</label>
            <input
              type="number"
              min="1"
              name="invoiceInstallmentCount"
              value={rentalDetails.invoiceInstallmentCount}
              onChange={handleRentalDetailChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Kira Başlangıç Tarihi</label>
            <input
              type="date"
              name="startDate"
              value={rentalDetails.startDate}
              onChange={handleRentalDetailChange}
            />
          </div>
          <div className="form-group">
            <label>Kira Bitiş Tarihi</label>
            <input
              type="date"
              name="endDate"
              value={rentalDetails.endDate}
              onChange={handleRentalDetailChange}
            />
          </div>
          <div className="form-group">
            <label>İlk Fatura Tarihi</label>
            <input
              type="date"
              name="firstInvoiceDate"
              value={rentalDetails.firstInvoiceDate}
              onChange={handleRentalDetailChange}
            />
          </div>
        </div>
  
            {/* Dosya Yükleme Alanları */}
            <div className="form-row">
              <div className="form-group">
                <label>Teklif Dosyası</label>
                <input type="file" multiple onChange={(e) => handleFileChange(e, 'Offer')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'Offer')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>

              <div className="form-group">
                <label>Sözleşme Dosyası</label>
                <input type="file" multiple onChange={(e) => handleFileChange(e, 'Contract')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'Contract')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Servis Formu</label>
                <input type="file" multiple onChange={(e) => handleFileChange(e, 'ServiceForm')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'ServiceForm')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>
              <div className="form-group">
                <label>Görseller</label>
                <input type="file" accept=".jpg, .jpeg, .png, .gif, .webp"   multiple onChange={(e) => handleFileChange(e, 'Image')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'Image')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Ödeme Dekontu</label>
                <input type="file" multiple onChange={(e) => handleFileChange(e, 'paymentDoc')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'paymentDoc')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>
              <div className="form-group">
                <label>Çek Görselleri</label>
                <input type="file" multiple onChange={(e) => handleFileChange(e, 'checkImages')} />
                <div className="file-names">
                  {files
                    .filter((file) => file.fileType === 'checkImages')
                    .map((file, index) => (
                      <div key={index} className="file-name">
                        {(index+1)+"."+ file.file || 'Dosya Yok'}
                      </div>
                    ))}
                </div>
              </div>
            </div>

  
        <div className="form-row notes-container">
          <label>İlk Faturaya Eklenecek Kalemler</label>
          <div className="form-group note-group">
            <strong>Hizmet Kalem Adı</strong>
            <strong>Adet</strong>
            <strong>Birim Fiyat</strong>
            <strong>Tutar</strong>
            <span />
          </div>
        {(rentalDetails.lineItems || []).map((item) => (
          <div key={item.localId} className="form-group note-group">
            <input
              type="text"
              value={item.description}
              onChange={(e) => handleLineItemChange(item.localId, 'description', e.target.value)}
              placeholder="Hizmet / Kalem Adı"
            />
              <input
                type="number"
                value={item.quantity}
                onChange={(e) => handleLineItemChange(item.localId, 'quantity', e.target.value)}
                placeholder="Adet"
              />
              <input
                type="number"
                value={item.unitPrice}
                onChange={(e) => handleLineItemChange(item.localId, 'unitPrice', e.target.value)}
                placeholder="Birim Fiyat"
              />
              <input
                type="text"
                value={(
                  Number(item.quantity || 0) * Number(item.unitPrice || 0)
                ).toLocaleString('tr-TR')}
                placeholder="Tutar"
                disabled
              />
              <button
                type="button"
                className="add-note-btn"
              onClick={() => removeLineItem(item.localId)}
              disabled={(rentalDetails.lineItems || []).length === 1}
            >
              Sil
            </button>
          </div>
        ))}
        <button type="button" onClick={addLineItem} className="add-note-btn">
          + Kalem Ekle
        </button>
      </div>

      <div className="form-row">
        <div className="form-group checkbox-group">
          <label>Uzatma Süresi Var mı?</label>
          <input
            type="checkbox"
            name="hasExtraPeriod"
            checked={rentalDetails.hasExtraPeriod}
            onChange={e =>
              setRentalDetails(prev => ({
                ...prev,
                hasExtraPeriod: e.target.checked,
                extraPeriod: 0,
                extraPeriodMonth: 0
              }))
            }
          />
        </div>

        {rentalDetails.hasExtraPeriod && (
          <>
            <div className="form-group">
              <label>Uzatma Süresi (Ay)</label>
              <input
                type="number"
                name="extraPeriodMonth"
                value={rentalDetails.extraPeriodMonth}
                onChange={e =>
                  setRentalDetails(prev => ({
                    ...prev,
                    extraPeriodMonth: parseInt(e.target.value, 10) || 0
                  }))
                }
              />
            </div>
            <div className="form-group">
              <label>Uzatma Süresi (Gün)</label>
              <input
                type="number"
                name="extraPeriod"
                value={rentalDetails.extraPeriod}
                onChange={e =>
                  setRentalDetails(prev => ({
                    ...prev,
                    extraPeriod: parseInt(e.target.value, 10) || 0
                  }))
                }
              />
            </div>
          </>
        )}
      </div>


        {/* Notlar */}
        <div className="form-row notes-container">
        <label>Notlar</label>

          {rentalDetails.notes.map((note, index) => (
            <div key={index} className="form-group note-group">

              <input
                type="text"
                name={`note-${index}`}
                value={note.note || ''} // Her notu input alanında göster
                onChange={(e) => handleNoteChange(index, e.target.value)}
                placeholder={`Not ${index + 1}`}
              />
            </div>
          ))}
          <button type="button" onClick={addNote} className="add-note-btn">+ Not Ekle</button>
        </div>

        <div className="button-group">
          <button className="submit-btn" onClick={handleRentalSubmit}>Kirayı Güncelle</button>
          <button className="end-rental-btn" onClick={() => setShowEndRentalModal(true)}>Kirayı Bitir</button>
        </div>
  
        {showEndRentalModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Kiralama Bitir</h3>
              <div className="form-group">
                <label>Depoya Gönder</label>
                <select value={warehouseId} onChange={(e) => setWarehouseId(e.target.value)}>
                  <option value="">Depo Seçin</option>
                  {warehouses.map((warehouse) => (
                    <option key={warehouse.id} value={warehouse.id}>{warehouse.name}</option>
                  ))}
                </select>
                <small className="add-link" onClick={() => setShowDepotModal(true)}>+ Depo Ekle</small>
              </div>
              <div className="form-group">

              <button className="confirm-btn" onClick={handleRentalEnd}>Onayla</button>
              <button className="close-btn" onClick={() => setShowEndRentalModal(false)}>Kapat</button>
            </div>
            </div>
          </div>
        )}
  
        {showDepotModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Yeni Depo Ekle</h3>
              <input
                type="text"
                value={newDepotName}
                onChange={(e) => setNewDepotName(e.target.value)}
                placeholder="Depo Adı"
                required
              />
              <input
                type="text"
                value={newDepotAddress}
                onChange={(e) => setNewDepotAddress(e.target.value)}
                placeholder="Depo Adresi"
                required
              />
              <button onClick={handleAddDepot}>Ekle</button>
              <button onClick={() => setShowDepotModal(false)}>İptal</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RentalEdit;
